 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/coverpage'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import ACCLAIM_FOR_UP_THROUGH_THE_WATER from '@/components/acclaim_for_up_through_the_water'
 import HALF_TITLE from '@/components/half_title'
 import OTHER_BOOKS_BY from '@/components/other_books_by'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import COMMENT from '@/components/comment'
 import HALF_TITLE_1 from '@/components/half_title_1'
 import JUNE from '@/components/June'
 import CHAPTER_01 from '@/components/chapter_01'
 import CHAPTER_02 from '@/components/chapter_02'
 import CHAPTER_03 from '@/components/chapter_03'
 import CHAPTER_04 from '@/components/chapter_04'
 import CHAPTER_05 from '@/components/chapter_05'
 import JULY from '@/components/July'
 import CHAPTER_06 from '@/components/chapter_06'
 import CHAPTER_07 from '@/components/chapter_07'
 import CHAPTER_08 from '@/components/chapter_08'
 import CHAPTER_09 from '@/components/chapter_09'
 import CHAPTER_10 from '@/components/chapter_10'
 import CHAPTER_11 from '@/components/chapter_11'
 import CHAPTER_12 from '@/components/chapter_12'
 import CHAPTER_13 from '@/components/chapter_13'
 import AUGUST from '@/components/August'
 import CHAPTER_14 from '@/components/chapter_14'
 import CHAPTER_15 from '@/components/chapter_15'
 import CHAPTER_16 from '@/components/chapter_16'
 import CHAPTER_17 from '@/components/chapter_17'
 import CHAPTER_18 from '@/components/chapter_18'
 import CHAPTER_19 from '@/components/chapter_19'
 import CHAPTER_20 from '@/components/chapter_20'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/coverpage",
 			"name" : "coverpage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/acclaim_for_up_through_the_water",
 			"name" : "acclaim_for_up_through_the_water",
 			"component" : ACCLAIM_FOR_UP_THROUGH_THE_WATER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/other_books_by",
 			"name" : "other_books_by",
 			"component" : OTHER_BOOKS_BY
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/comment",
 			"name" : "comment",
 			"component" : COMMENT
 		},
 		{
 			"path" : "/half_title_1",
 			"name" : "half_title_1",
 			"component" : HALF_TITLE_1
 		},
 		{
 			"path" : "/June",
 			"name" : "June",
 			"component" : JUNE
 		},
 		{
 			"path" : "/chapter_01",
 			"name" : "chapter_01",
 			"component" : CHAPTER_01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js